import {
  AutocompleteInput,
  ReferenceInput,
  TextInput,
} from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";

const filterToQuery = (searchText) => ({ all: searchText });

const saleOrderFilterList = () => {
  return [
    // <TextInput
    //   source="all"
    //   label="mine.filter.search_all"
    //   alwaysOn
    //   resettable
    //   variant="outlined"
    //   InputProps={{
    //     endAdornment: (
    //       <InputAdornment position="end">
    //         <SearchIcon />
    //       </InputAdornment>
    //     ),
    //   }}
    // />,
    <TextInput
      alwaysOn
      source="code"
      label="mine.label.receipt_no"
      resettable
      variant="outlined"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="start_date"
      label="mine.label.start_date"
      variant="outlined"
      maxDateSource="end_date"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="end_date"
      label="mine.label.end_date"
      variant="outlined"
      minDateSource="start_date"
    />,
    <ReferenceInput source="customer_id" reference="customers" alwaysOn>
      <AutocompleteInput
        label="mine.label.customer"
        optionText="name"
        variant="outlined"
        filterToQuery={filterToQuery}
      />
    </ReferenceInput>,
    <ReferenceInput source="salesman_id" reference="salesmen" alwaysOn>
      <AutocompleteInput
        optionText="name"
        variant="outlined"
        filterToQuery={filterToQuery}
      />
    </ReferenceInput>,
  ];
};
export default saleOrderFilterList;
